import type { RootState } from "@store/store";
import { CHALLAN_MENU_KEY } from "../config/menu.keys";
import { MODAL_KEYS } from "@constants/global.constants";

// Menu item type
interface MenuItem {
	key: string;
	label: string;
	icon: React.ReactNode;
	route: string;
	children?: MenuItem[];
}

export const openItemOnSideBarClick = (
	item: MenuItem,
	hasChildren: boolean,
	toggleMenu: (key: string) => void,
	openModal: (modalKey: keyof RootState["modal"]) => void,
	navigate: (route: string) => void,
) => {
	if (hasChildren) {
		toggleMenu(item.key);
	} else if (item.key === CHALLAN_MENU_KEY) {
		openModal(MODAL_KEYS.CHALLAN_CUSTOMIZE);
	} else {
		navigate(item.route);
	}
};
